import { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { Form } from 'antd'

import { AppContext } from '../../context/AppContext'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'
import CommunityIconEditor from '../../components/forms/CommunityIconEditor'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import DeleteButton from '../../components/DeleteButton'

import {
    CommunityDescription,
    cleanBeforeSending,
    formatCommunityData,
} from '../../constants/forms/Communities'
import {
    editCommunity,
    getSingleCommunity,
    deleteCommunity,
} from '../../network/API'

const CommunityDetails = () => {
    const { token } = useContext(AppContext)
    const [form] = Form.useForm()
    const [isDeleted, setIsDeleted] = useState(false)
    const { communityId } = useParams()

    const communityDetails = useQuery(
        [
            'getSingleCommunity',
            {
                communityId,
                token: token.token,
            },
        ],
        getSingleCommunity,
        {
            refetchOnWindowFocus: false,
        }
    )

    return (
        <PageWrap
            goBack
            isLoading={communityDetails.isLoading}
            title={communityDetails.data?.name || 'COMMUNITY'}
            actionOptions={[
                <DeleteButton
                    onSuccess="/communities"
                    request={deleteCommunity}
                    id={communityId}
                    invalidate={['getCommunities', 'getSingleCommunity']}
                    isDeleted={setIsDeleted}
                />,
            ]}
        >
            {communityDetails.isError ? (
                <Error retry={() => communityDetails.refetch()} />
            ) : communityDetails.isLoading ? (
                <Loader />
            ) : (
                <FormWrap
                    title="edit_community"
                    form={form}
                    request={editCommunity}
                    id={communityId}
                    onSuccess="/communities"
                    onCancel="/communities"
                    data={formatCommunityData(communityDetails.data)}
                    cleanBeforeSending={cleanBeforeSending}
                    invalidate={['getCommunities', 'getSingleCommunity']}
                    isDeleted={isDeleted}
                >
                    <div className="SectionVerticalWrap">
                        <FormBlock form={form} formTemplate={CommunityDescription} />
                        <CommunityIconEditor />
                    </div>
                </FormWrap>
            )}
        </PageWrap>
    )
}

export default CommunityDetails
